module.exports = __webpack_public_path__ + "static/lato-latin-100italic.0c146ee0.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-100italic.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-100italic.woff
// module chunks = 17241999800008180000